import { Component, OnInit } from '@angular/core';
import { LambdaService } from 'src/app/lambda.service';
import { ThemingService } from 'src/app/theming.service';

@Component({
  selector: 'app-sale-logs',
  templateUrl: './sale-logs.component.html',
  styleUrls: ['./sale-logs.component.scss']
})
export class SaleLogsComponent implements OnInit {

  // === ESTADO DEL COMPONENTE ===
  logs: any[] = [];
  totalLogs = 0;
  currentPage = 1;
  pageSize = 20;
  loading = false;
  expandedLog: number | null = null;
  errorMessage: string | null = null;

  // === FILTROS ===
  filters: any = {
    logType: '',
    startDate: '',
    endDate: '',
    search: ''
  };

  // === OPCIONES PARA SELECTS ===
  logTypeOptions = [
    { value: '', label: 'Todos los tipos' },
    { value: 'SALE_PAYMENT_SUCCESS', label: '✅ Exitosos' },
    { value: 'SALE_PAYMENT_FAILED', label: '❌ Fallidos' }
  ];

  constructor(
    public themingService: ThemingService,
    private lambdaService: LambdaService
  ) { }

  ngOnInit(): void {
    this.loadLogs();
  }

  // === CARGA DE LOGS ===
  async loadLogs() {
    this.loading = true;
    await this.lambdaService.getSaleLogs(this.themingService.shopId,this.filters,this.currentPage,this.pageSize)
    .then((data: any) => {
      console.log(data.data);
      this.logs = data.data;
    })
    .catch((error) => {
      console.error(error);
      this.loading = false;
    });
    this.loading = false;
  }

  // === ACCIONES DE UI ===
  toggleExpand(logId: number): void {
    this.expandedLog = this.expandedLog === logId ? null : logId;
  }

  applyFilters(): void {
    this.currentPage = 1;
    this.loadLogs();
  }

  clearFilters(): void {
    this.filters = {
      logType: '',
      startDate: '',
      endDate: '',
      search: ''
    };
    this.loadLogs();
  }

  formatDate(dateString: string): string {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleString('es-CR', {
      timeZone: 'America/Costa_Rica',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  getStatusBadgeClass(logType: string): string {
    switch (logType) {
      case 'SALE_PAYMENT_SUCCESS': return 'bg-success';
      case 'SALE_PAYMENT_FAILED': return 'bg-danger';
      default: return 'bg-secondary';
    }
  }

  getStatusText(logType: string): string {
    switch (logType) {
      case 'SALE_PAYMENT_SUCCESS': return 'Exitoso';
      case 'SALE_PAYMENT_FAILED': return 'Fallido';
      default: return logType;
    }
  }

  copyToClipboard(content: any): void {
    const text = typeof content === 'string' ? content : JSON.stringify(content, null, 2);
    navigator.clipboard.writeText(text).then(() => {
      // Opcional: mostrar toast de confirmación
      console.log('Copiado al portapapeles');
    });
  }

  // === PAGINACIÓN ===
  get totalPages(): number {
    return Math.ceil(this.totalLogs / this.pageSize);
  }

  getPagesArray(): number[] {
    const pages: number[] = [];
    const maxVisible = 5;
    let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(this.totalPages, start + maxVisible - 1);
    
    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }
    
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.currentPage) return;
    this.currentPage = page;
    this.loadLogs();
  }

  // === UTILIDADES PARA JSON ===
  isJsonEmpty(obj: any): boolean {
    return !obj || Object.keys(obj).length === 0;
  }

}
